import { IAttrValue } from "@multiweb/types/contracts";
import { EMPTY_ITEM_RIGHTS_COLLECTION } from "Global/Base/Rights/RightTypes";
import { AttrValueReader } from "../../../../../../../OW.Remoting/Remoting/AttrValueReader";
import { IValidatable } from "../../../../../../UI.BaseControls/ControlInterfaces";
import { Column } from "../../../../../../UI.Controls/DataGridSubcontrols/Columns/Column";
import { EditItemTemplate } from "../../../../../../UI.Controls/DataGridSubcontrols/Templates/EditItemTemplate";
import { ElementUtils } from "../../../../../../UI.ElementarControls/Helpers/ElementUtils";
import { CheckBox } from "../../../../Controls/CheckBox";
import { IHTMLElementWithControl } from "../../../../Controls/ControlInterfaces";

export class BooleanEditTemplate extends EditItemTemplate {
    public override updateData(dataSet: IAttrValue[], item: HTMLElement): void {
        const chbox = (item as IHTMLElementWithControl).tscControl as CheckBox;
        chbox.controlValue = AttrValueReader.read(this._getDataFromSet(dataSet));
    }

    protected override _createEditElement(column: Column, dataSet: IAttrValue[], parentItem: HTMLElement): { element: HTMLElement; validatableControl: IValidatable } {
        const checkBox = new CheckBox({ element: document.createElement("div"), originalRightsDefinition: EMPTY_ITEM_RIGHTS_COLLECTION });
        checkBox.enabledVisual = false; //předejde se tak možnosti editovat hodnotu dříve než to povolí práva
        checkBox.attrName = column.attrName;
        checkBox.displayFormat = column.displayFormat;
        checkBox.dataType = column.dataType;
        checkBox.controlValue = AttrValueReader.read(this._getDataFromSet(dataSet));
        checkBox.isEditing = true;
        checkBox.valueChanged.add(() => {
            ElementUtils.callEvent(parentItem, "valuechanged", { value: checkBox.controlValue, column: column });
        });
        return { element: checkBox.element, validatableControl: checkBox };
    }
}
